import axios from "axios";
import { ip_back } from "../../config";

const getToken = () => localStorage.getItem("token");

const headers = () => ({
  headers: { Authorization: getToken() },
});

export const getExerciseLookups = async () => {
  try {
    const response = await axios.get(`${ip_back}api/exerciseManagement/lookups`, headers());
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const getExerciseList = async (params) => {
  try {
    const response = await axios.get(`${ip_back}api/exerciseManagement/list`, {
      ...headers(),
      params,
    });
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const getExerciseForEdit = async (ex_id) => {
  try {
    const response = await axios.get(`${ip_back}api/exerciseManagement/${ex_id}`, headers());
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const createExercise = async (data) => {
  try {
    const response = await axios.post(`${ip_back}api/exerciseManagement/`, data, headers());
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const updateExercise = async (ex_id, data) => {
  try {
    const response = await axios.put(`${ip_back}api/exerciseManagement/${ex_id}`, data, headers());
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const deleteExercise = async (ex_id) => {
  try {
    const response = await axios.delete(`${ip_back}api/exerciseManagement/${ex_id}`, headers());
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const exportExercises = async () => {
  try {
    const response = await axios.get(`${ip_back}api/exerciseManagement/export`, {
      ...headers(),
      responseType: "blob",
    });
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const importExercises = async (file, mode) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("mode", mode);
    const response = await axios.post(`${ip_back}api/exerciseManagement/import`, formData, {
      headers: { Authorization: localStorage.getItem("token"), "Content-Type": "multipart/form-data" },
    });
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};

export const bulkClassifyExercises = async (payload) => {
  try {
    const response = await axios.post(
      `${ip_back}api/exerciseManagement/bulk-classify`,
      payload,
      headers()
    );
    if (response.data.status === "error") throw response.data;
    return response;
  } catch (error) {
    if (error.response?.status === 401) localStorage.clear();
    throw error.response?.data ?? { status: "error", message: error.message || "Network error" };
  }
};
